import { render, staticRenderFns } from "./VChzzkIcon.vue?vue&type=template&id=8aaf9ce6&scoped=true"
import script from "./VChzzkIcon.vue?vue&type=script&lang=js"
export * from "./VChzzkIcon.vue?vue&type=script&lang=js"
import style0 from "./VChzzkIcon.vue?vue&type=style&index=0&id=8aaf9ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaf9ce6",
  null
  
)

export default component.exports